"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandColumn = void 0;
const _ = __importStar(require("lodash"));
const slickgrid_1 = require("slickgrid");
const formatters_1 = require("../formatters");
const DEFAULTS = {
    name: '',
    toolTip: '',
    cssClass: '',
    width: 30,
    frozen: false,
    systemColumn: false,
    filterable: true,
    resizable: true,
    sortable: true,
    hideable: true
};
function isAnchor(element) {
    return element instanceof HTMLAnchorElement || element.closest('a');
}
function getAnchor(element) {
    if (element instanceof HTMLAnchorElement) {
        return element;
    }
    const el = element.closest('a');
    if (el instanceof HTMLAnchorElement) {
        return el;
    }
}
class CommandColumn {
    pluginName = 'CommandColumn';
    eventHandler;
    grid;
    selectedRows;
    callback;
    onCommand;
    id;
    name;
    field;
    rowSelector;
    formatter;
    headerCssClass;
    maxWidth;
    minWidth;
    rerenderOnResize;
    resizable;
    selectable;
    sortable;
    hideable;
    toolTip;
    width;
    flags;
    preventCellActivate;
    constructor(options) {
        _.extend(this, options);
        if (!this.formatter) {
            this.formatter = (0, formatters_1.clicksink)();
        }
        this.onCommand = new slickgrid_1.SlickEvent();
        this.eventHandler = new slickgrid_1.SlickEventHandler();
        this.callback = options && options.onCommand;
        this.preventCellActivate = this.flags && this.flags['preventCellActivate'];
    }
    init(grid) {
        this.grid = grid;
        this.eventHandler.subscribe(grid.onClick, this.onClick.bind(this));
    }
    destroy() {
        this.eventHandler.unsubscribeAll();
    }
    onClick(e, args) {
        const anchor = getAnchor(e.target);
        if (this.grid.getColumns()[args.cell].id === this.id && anchor) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (!this.preventCellActivate) {
                this.grid.setActiveCell(args.row, args.cell);
            }
            const row = args.row, data = this.grid.getDataItem(row);
            this.notify({
                column: this,
                row,
                data,
                element: e.target,
                value: anchor.dataset.value
            });
        }
        return false;
    }
    notify(args) {
        this.onCommand.notify(args);
        if (this.callback) {
            this.callback(args);
        }
    }
}
exports.CommandColumn = CommandColumn;
//# sourceMappingURL=CommandColumn.js.map